/**
 * Who may export from Leads (#869 AC7): Biler, Mine Leads, Hendelser, the
 * eierhistorikk dialog and, since #885, Bedrifter, Nyheter and every table on
 * the bedrift page all ask this one hook. Without the role the buttons are
 * hidden, not shown locked.
 *
 * Its own module for the same reason as eierhistorikk/tilgang.ts: a file that
 * exports both a component and a hook breaks React Fast Refresh.
 */
import { useAuth } from '../../contexts/AuthContext'
import { hasAnyRole, ROLE_LEADS_TABLE_EXPORTER } from '../../utils/roles'

/** Rows in one export from a paged Leads table (#885): COUNT_CAP on the
 *  backend. Over the page maximum the endpoint requires the role. */
export const LEADS_EXPORT_LIMIT = 1000

export function useKanEksportere(): boolean {
  const { user } = useAuth()
  return hasAnyRole(user, [ROLE_LEADS_TABLE_EXPORTER])
}
